import { render, staticRenderFns } from "./courseListEdit_new.vue?vue&type=template&id=5e56d2a6&scoped=true"
import script from "./courseListEdit_new.vue?vue&type=script&lang=js"
export * from "./courseListEdit_new.vue?vue&type=script&lang=js"
import style0 from "./courseListEdit_new.vue?vue&type=style&index=0&id=5e56d2a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e56d2a6",
  null
  
)

export default component.exports